import 'twin.macro';
import 'styled-components/macro';

import { Placeholder } from 'component-lib/molecules/placeholder/Placeholder';

import empty from './empty-terminal-placeholder.svg';

export const TerminalTabPlaceholder = () => {
  return <Placeholder tw="bg-[#1E2637] p-0 h-full rounded-none" illustration={empty} />;
};
